import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import {
  Button,
  __experimentalInputControl as InputControl,
  PanelBody,
  RangeControl,
  TextareaControl,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";

function IconUploader({ value, onChange }) {
  return (
    <div>
      <label
        class="components-base-control__label"
        style={{
          fontSize: "11px",
          fontWeight: 500,
          lineHeight: "1.4",
          textTransform: "uppercase",
          display: "block",
          marginBottom: "calc(8px)",
          padding: "0px",
        }}
      >
        {__("ICON (OPTIONAL)", "brandy-blocks")}
      </label>
      {value && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "6px",
          }}
        >
          <img
            src={value}
            alt=""
            style={{
              width: "32px",
              height: "32px",
              objectFit: "contain",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          />
          <Button variant="tertiary" isDestructive onClick={() => onChange("")}>
            {__("Remove", "brandy-blocks")}
          </Button>
        </div>
      )}
      <MediaUploadCheck>
        <MediaUpload
          onSelect={(media) => onChange(media.url)}
          allowedTypes={["image"]}
          value={value}
          render={({ open }) => (
            <Button variant="secondary" onClick={open}>
              {value
                ? __("Change icon", "brandy-blocks")
                : __("Upload icon", "brandy-blocks")}
            </Button>
          )}
        />
      </MediaUploadCheck>
    </div>
  );
}

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const { locations = [], zoomLevel } = attributes;

  const updateLocation = (index, patch) => {
    const updated = locations.map((loc, i) =>
      i === index ? { ...loc, ...patch } : loc,
    );
    setAttributes({ locations: updated });
  };

  const removeLocation = (index) => {
    setAttributes({ locations: locations.filter((_, i) => i !== index) });
  };

  const addLocation = () => {
    setAttributes({
      locations: [...locations, { address: "", iconUrl: "", popupText: "" }],
    });
  };

  return (
    <PanelBody title={__("Settings", "brandy-blocks")}>
      {locations.map((loc, index) => (
        <div
          key={index}
          style={{
            marginBottom: "12px",
            paddingBottom: "12px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <InputControl
            label={`${__("Address", "brandy-blocks")} ${index + 1}`}
            value={loc.address || ""}
            onChange={(value) => updateLocation(index, { address: value })}
          />
          <div style={{ marginTop: "8px" }}>
            <IconUploader
              value={loc.iconUrl || ""}
              onChange={(url) => updateLocation(index, { iconUrl: url })}
            />
          </div>
          <div style={{ marginTop: "8px" }}>
            <TextareaControl
              __nextHasNoMarginBottom
              label={__("Popup text (optional)", "brandy-blocks")}
              value={loc.popupText || ""}
              onChange={(value) => updateLocation(index, { popupText: value })}
              rows={2}
            />
          </div>
          <Button
            variant="secondary"
            isDestructive
            onClick={() => removeLocation(index)}
            style={{ marginTop: "8px" }}
          >
            {__("Remove", "brandy-blocks")}
          </Button>
        </div>
      ))}
      <Button
        variant="secondary"
        onClick={addLocation}
        style={{ marginTop: "4px", marginBottom: "16px" }}
      >
        {__("+ Add location", "brandy-blocks")}
      </Button>
      <RangeControl
        __nextHasNoMarginBottom
        label={__("Zoom level", "brandy-blocks")}
        value={zoomLevel ?? 12}
        onChange={(value) => setAttributes({ zoomLevel: value })}
        min={1}
        max={20}
      />
    </PanelBody>
  );
}
